import { render, staticRenderFns } from "./Scholarship.vue?vue&type=template&id=0418f958&scoped=true&"
import script from "./Scholarship.vue?vue&type=script&lang=js&"
export * from "./Scholarship.vue?vue&type=script&lang=js&"
import style0 from "./Scholarship.vue?vue&type=style&index=0&id=0418f958&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0418f958",
  null
  
)

export default component.exports